import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

type HistoryState = {
  usr?: unknown;
  key?: string;
  idx?: number;
};

/**
 * Sur mobile / WebView, l'entrée "/" est souvent absente de l'historique
 * (idx === 0 alors qu'on n'est pas sur l'accueil). Le Retour quitte alors
 * le site au lieu de ramener à la home.
 *
 * Si on détecte ce cas, on réinsère "/" sous la page courante sans changer
 * l'écran affiché.
 */
export function useEnsureHomeInHistory() {
  const location = useLocation();
  const lastFixedRef = useRef<string | null>(null);

  useEffect(() => {
    if (location.pathname === "/") {
      lastFixedRef.current = null;
      return;
    }

    const state = (window.history.state || {}) as HistoryState;
    const idx = typeof state.idx === "number" ? state.idx : 0;
    if (idx > 0) return;

    const currentUrl = location.pathname + location.search + location.hash;
    if (lastFixedRef.current === currentUrl) return;
    lastFixedRef.current = currentUrl;

    try {
      window.history.replaceState(
        { usr: null, key: "home", idx: 0 },
        "",
        "/"
      );
      window.history.pushState(
        {
          usr: location.state ?? null,
          key: location.key || "default",
          idx: 1,
        },
        "",
        currentUrl
      );
    } catch {
      // ignore: certains WebViews restreignent history
    }
  }, [
    location.pathname,
    location.search,
    location.hash,
    location.key,
    location.state,
  ]);
}
